__turbopack_context__.v({
  "BtnWrapper": "ClearDueModal-module-scss-module__giC-VG__BtnWrapper",
});
